module.exports = __webpack_public_path__ + "img/small arrow.b7f1eb47.svg";